import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { Loading } from '../../../../../common/loading'
import { getNoDataComponent, handleIconDownload } from '../../helper'
import classes from '../../index.module.scss'
import { Table } from './Table'
import {
  selectIndicators,
  selectLoading,
  selectOverallAssessment,
} from './store/slice'

const QuickAssessment = ({ isDynamicReport, id }) => {
  const loading = useSelector(selectLoading)
  const overallAssessment = useSelector(selectOverallAssessment)
  const indicators = useSelector(selectIndicators)

  const length = indicators.length
  const halfLength = length / 2
  const leftIndicators = indicators.slice(0, Math.ceil(halfLength))
  const rightIndicators = indicators.slice(Math.ceil(halfLength), length)

  const isNoData = !indicators?.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (loading) return <Loading />

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  return (
    <Element
      style={{ color: '#3A414B' }}
      className={`${classes.containerPanel2} ${classes.quickAssessmentContainer}`}
    >
      <div>
        {!!overallAssessment.length &&
          overallAssessment.map((item) => (
            <Element
              style={{
                background: '#EDF5FE',
                borderLeft: '3px solid #0553A5',
              }}
              className={classes.itemInfo}
            >
              <Icon
                style={{ color: '#0553A5' }}
                className="icon-info-circle-outline"
              />
              <span>{item.content}</span>
            </Element>
          ))}
      </div>
      <div
        style={{ marginTop: !overallAssessment.length ? '-8px' : undefined }}
        className={classes.tableContainer}
      >
        <Table itemsLeft={leftIndicators} itemsRight={rightIndicators} />
      </div>
    </Element>
  )
}

export default QuickAssessment
